<template>
    <ModalWrapper v-model="modal" width="600" scrollable>
        <template v-slot:title>
            <div class="d-flex flex-column">
                <div class="d-flex align-center">
                    <strong class="info-text text-h6">
                        {{
                            service.serviceDetails[0].transferName
                                ? service.serviceDetails[0].transferName
                                : service.serviceName
                        }}
                    </strong>
                    <v-chip v-if="serviceType" label size="x-small" class="ms-2">
                        {{ serviceType }}
                    </v-chip>
                    <hotel-stars
                        v-if="service.serviceDetails[0].category || service.serviceDetails[0].ratings"
                        class="ms-2"
                        :hotel="service.serviceDetails[0]"
                    />
                </div>
                <span v-if="service.productNameForSupplier && isTO1" class="text-caption text--secondary">
                    {{ service.productNameForSupplier }}
                </span>
            </div>
        </template>
        <div>
            <v-tabs v-model="tab" class="mb-4">
                <v-tab value="info"> {{ $t('description') }}</v-tab>
                <v-tab v-if="isShowCustomDescriptionTab" value="customInfo">
                    {{ $t('edit_custom_product_info') }}</v-tab
                >
            </v-tabs>
            <v-tabs-window v-model="tab">
                <v-tabs-window-item value="info">
                    <v-skeleton-loader v-if="isInfoLoading" type="paragraph" />
                    <v-img
                        v-if="image"
                        tile
                        class="thumb mb-2"
                        :src="$filters.imageUrl(image, 800)"
                        :lazy-src="$filters.srcHost('/placeholder.png')"
                        height="250"
                        :eager="true"
                        @error="onImgError"
                    >
                        <template v-slot:placeholder>
                            <v-row v-show="!imgError && image" class="fill-height ma-0" align="center" justify="center">
                                <v-progress-circular indeterminate color="grey-lighten-5" />
                            </v-row>
                        </template>
                    </v-img>
                    <slot name="serviceInfo" />
                    <slot name="extraInfo" />
                </v-tabs-window-item>
                <v-tabs-window-item value="customInfo">
                    <custom-product-info-form
                        v-if="isShowCustomDescriptionTab"
                        :service="service"
                        @close="tab = 'info'"
                        @close-modal="closeModal"
                    />
                </v-tabs-window-item>
            </v-tabs-window>
        </div>
    </ModalWrapper>
</template>

<script lang="ts">
    import {Component, Emit, Prop, Vue, VModel} from 'vue-facing-decorator'
    import HotelStars from '~src/components/hotels/snippets/hotelStars.src'
    import CustomProductInfoForm from '@/components/account/orderServices/CustomProductInfoForm.vue'

    @Component({
        components: {CustomProductInfoForm, HotelStars},
    })
    export class ServiceInfoDialog extends Vue {
        @VModel() modal

        @Prop() service
        @Prop() serviceType
        @Prop() info
        @Prop() isInfoLoading
        @Prop({default: null}) image
        @Prop({default: false, type: Boolean}) enableCustomProductInfo

        imgError = false
        tab = 'info'

        @Emit()
        closeModal() {}

        onImgError() {
            this.imgError = true
            return false
        }

        get isTO1() {
            return authStore.isTO1
        }

        get ownProduct() {
            return runtimeStore.ownProduct(this.service.supplierCode)
        }

        get isShowCustomDescriptionTab() {
            return (
                this.isTO1 &&
                this.enableCustomProductInfo &&
                this.$conf.public.account.enableCustomProductInfo &&
                !this.ownProduct
            )
        }
    }

    export default ServiceInfoDialog
</script>

<style lang="scss" scoped>
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.3s;
    }
    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }
</style>
